import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';



const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    padding: `${theme.spacing.unit * 3}px 0`,
    paddingRight: `${theme.spacing.unit * 1}px`,
  },
  textField: {
    paddingRight: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  option: {
    margin: `${theme.spacing.unit * 7}px 0`,
  },
});


class BillingRatesForm extends React.Component {

  state = {}

  render = () => {
    const {classes, order, actions, showErrors} = this.props

    const {
      _errors,
      regularLaborRate,
      overtimeLaborRate,
    } = order

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={1}/>
          <Grid item xs={12} sm={10}>
            <Typography variant="body1" style={{marginBottom: `2em`}}>
              Please enter the billing rates you would like to use to calculate
              your repair prices. If you do not charge an after hours premium,
              enter the same billing rate for after hours.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={1}/>

          <Grid item xs={12} sm={1} md={2}/>
          <Grid item xs={12} sm={5} md={4}>
            <TextField
              fullWidth
              error={!!((regularLaborRate.length || showErrors) && _errors.regularLaborRate)}
              className={classes.textField}
              variant="outlined"
              label="Regular Rate"
              value={regularLaborRate}
              onChange={e => actions.updateOrder(order, {regularLaborRate: e.target.value})}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={5} md={4}>
            <TextField
              fullWidth
              error={!!((overtimeLaborRate.length || showErrors) && _errors.overtimeLaborRate)}
              className={classes.textField}
              variant="outlined"
              label="After Hours Rate"
              value={overtimeLaborRate}
              onChange={e => actions.updateOrder(order, {overtimeLaborRate: e.target.value})}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={1} md={2}/>

          <Grid item xs={12} sm={1}/>
          <Grid item xs={12} sm={10}>
            <Typography variant="body2" style={{margin: `2em 0`}}>
              Remember, repairs are billed in actual Transaction (labor) Times.
              Minimum dollar amounts do not apply. Diagnostic/Service Call fees are additional.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={1}/>
        </Grid>
      </div>
    )
  }
}

BillingRatesForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(BillingRatesForm);
